import React, { useState, useEffect } from "react";
import Container from "@mui/material/Container";
import { Box, Grid, Typography } from "@mui/material";
import "../../utils/styles/Home/Certificados/CertificadosStyles.scss";
import logoSgs from "../../utils/img/Logos/sgs.png";
import Iso39001 from "../../utils/img/Logos/Iso39001.png";
import logoHodelpe from "../../utils/img/Logos/Logo-Hodelpe.png";

const CertiBar = () => {
  const logos = [logoSgs, Iso39001, logoHodelpe];
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 600);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 600);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (isMobile) {
      const interval = setInterval(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % logos.length);
      }, 2000);
      return () => clearInterval(interval);
    }
  }, [isMobile]);

  return (
    <Box style={{ background: "#d3d3d36e", marginBottom: "80px", padding: "30px 0", display: "flex", alignItems: "center" }}>
      <Container>
        <Grid container spacing={3} justifyContent="center" alignItems="center">
          <Grid item md={5} xs={10} sm={8} className="containerMision">
            <Box className="contenedor1">
              <Typography className="textCertificado" textAlign="center">
                Estamos certificados por los organismos más reconocidos
              </Typography>
            </Box>
          </Grid>
          <Grid item md={5} xs={10} sm={8} style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
            <Box className="contenedor1CertificadosHome" style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "150px" }}>
              {isMobile ? (
                <img
                  src={logos[currentIndex]}
                  className="imgcertificados"
                  style={{ width: "120px", height: "120px", objectFit: "contain", transition: "opacity 0.5s ease-in-out" }}
                  alt="Certificación"
                />
              ) : (
                logos.map((logo, index) => (
                  <img key={index} src={logo} className="imgcertificados" style={{ width: "120px", height: "120px", objectFit: "contain", margin: "0 10px" }} alt="Certificación" />
                ))
              )}
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default CertiBar;